import {Periodicity} from "@app/strain/config/risk-classes/models/periodicity.model";

export class RiskClass {

    public id: number;
    public name: string;
    public description: string;
    public type: number;
    public minValue: number;
    public maxValue: number;
    public timeUnit: number;
    public periodicity: Periodicity;

    constructor(riskCLass: any = {}) {
        this.id = riskCLass.id || null;
        this.name = riskCLass.name || '';
        this.description = riskCLass.description || '';
        this.type = riskCLass.type;
        this.minValue = riskCLass.minValue;
        this.maxValue = riskCLass.maxValue;
        this.timeUnit = riskCLass.timeUnit;
        this.periodicity = riskCLass.periodicity;
    }

}
